import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: API_URL,
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  register: (data) => api.post('/api/auth/register', data),
  login: (username, password) => {
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    return api.post('/api/auth/login', formData);
  },
  getMe: () => api.get('/api/auth/me'),
};

export const personAPI = {
  getAll: () => api.get('/api/persons'),
  getById: (id) => api.get(`/api/persons/${id}`),
  create: (data) => api.post('/api/persons', data),
  update: (id, data) => api.put(`/api/persons/${id}`, data),
  delete: (id) => api.delete(`/api/persons/${id}`),
  importJSON: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/api/import/json', formData);
  },
};

export const fileAPI = {
  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/api/upload/file', formData);
  },
  getContent: (filename) => api.get(`/api/files/content`, { params: { filename } }),
  saveContent: (filename, content) => {
    const formData = new FormData();
    formData.append('filename', filename);
    formData.append('content', content);
    return api.post('/api/files/content', formData);
  },
};

export const settingsAPI = {
  getTikTokCookies: () => api.get('/api/user/settings/tiktok-cookies'),
  setTikTokCookies: (cookies) => api.post('/api/user/settings/tiktok-cookies', { cookies }),
  getInstagramCookies: () => api.get('/api/user/settings/instagram-cookies'),
  setInstagramCookies: (cookies) => api.post('/api/user/settings/instagram-cookies', { cookies }),
};

export const tiktokAPI = {
  download: (personId, url, account) => api.post('/api/tiktok/download', { personId, url, account }),
  deleteVideo: (personId, id) => api.post('/api/tiktok/delete', { personId, id }),
};

export const instagramAPI = {
  download: (personId, url, account) => api.post('/api/instagram/download', { personId, url, account }),
  deletePost: (personId, id) => api.post('/api/instagram/delete', { personId, id }),
  deleteMedia: (personId, postId, filename) => api.post('/api/instagram/delete-media', { personId, postId, filename }),
};

export const geocodeAPI = {
  geocode: (address, personId) => api.post('/api/geocode', { address, personId }),
};

export const osintAPI = {
  startScan: (personId) => api.post(`/api/osint/scan/${personId}`),
  getStatus: (jobId) => api.get(`/api/osint/status/${jobId}`),
  getResults: (personId) => api.get(`/api/osint/results/${personId}`),
  getJobs: (personId) => api.get(`/api/osint/jobs/${personId}`),
  mergeResults: (personId, findingIds, action = 'merge') =>
    api.post(`/api/osint/merge/${personId}`, { finding_ids: findingIds, action }),
  deleteJob: (jobId) => api.delete(`/api/osint/jobs/${jobId}`),
  getSettings: () => api.get('/api/osint/settings'),
  saveSettings: (settings) => api.post('/api/osint/settings', settings),
};

export default api;